export default __webpack_public_path__ + "static/media/photo--sm--17.113795b1.jpg";